import {
  Row, Card, Button, Col, Typography,
} from 'taxaroo-ui';
import CheckMark from 'src/assets/icons/checkmark.svg';
import XMark from 'src/assets/icons/xmark.svg';
import MagicWand from 'src/assets/icons/magic-wand.svg';
import * as styles from './styles.module.css';
import { AiAssistantPlanType } from '.';
import { TaxarooAIVideoPoster } from './utils';
import { PlanStatus, PlanStatusMap } from './AddonsModalContent';

const { Text } = Typography;
const taxarooAiVideoSrc = 'https://taxaroo-public1.s3.us-east-1.amazonaws.com/video/taxaroo_ai.mp4';

// modal titles
export const basicModalTitle = (
  <Row style={{ fontSize: '36px' }}>
    Proceed to checkout AI Video Plan?
  </Row>
);

export const premiumModalTitle = (
  <Row style={{ fontSize: '36px' }}>
    Proceed to checkout&nbsp;
    <Text className={styles.blueText}>AI VideoPro Plan</Text>
    ?
  </Row>
);

export const chatOnlyModalTitle = (
  <Row style={{ fontSize: '36px' }}>
    Proceed to checkout AI Chat Plan?
  </Row>
);

export const defaultModalTitle = (
  <>
    <Row style={{ fontSize: '36px', padding: '10px 0' }}>
      Upgrade Your Firm Efficiency with Taxaroo AI.
    </Row>
    <Row style={{ fontSize: '36px' }}>
      <Text className={styles.blueText}>24/7</Text>
      <Text>&nbsp;work &amp; support.</Text>
    </Row>
  </>
);

// modal headers
export const basicModalHeader = (
  <Row style={{ fontSize: '20px' }}>
    Confirm your purchase
  </Row>
);

export const premiumModalHeader = (
  <Row style={{ fontSize: '20px' }}>
    Confirm your purchase
  </Row>
);

export const chatOnlyModalHeader = (
  <Row style={{ fontSize: '20px' }}>
    Confirm your purchase
  </Row>
);

export const returnDefaultModalHeader = (defaultPaymentMethod: string, handleUpdatePaymentMethod: () => void) => (
  defaultPaymentMethod
    ? (
      <>
        <Row style={{ fontSize: '20px' }}>
          Get AI support that helps you with tax questions and automates tasks for you.
        </Row>
        <Row style={{ fontSize: '20px' }}>
          Upgrade your Taxaroo experience with Taxaroo AI.
        </Row>
      </>
    )
    : (
      <Row style={{ fontSize: '20px' }}>
        You are currently on a trial plan.&nbsp;
        <Button
          type="link"
          onClick={() => handleUpdatePaymentMethod()}
          style={{ padding: 0, fontSize: '20px' }}
        >
          <Text style={{ textTransform: 'capitalize', color: '#3d80f3' }}>Click here</Text>
        </Button>
        &nbsp;to add a payment method to experience Taxaroo AI.
      </Row>
    )
);

// modal contents
export const chatOnlyModalContent = (
  <Row gutter={[30, 50]} className={styles.modalCheckoutContent}>
    <Col xs={24} md={8} style={{ marginRight: { xs: 0, md: '40px' }, marginBottom: { xs: '20px', md: 0 } }}>
      <Card className={styles.modalCardCheckout} bodyStyle={{ padding: '10px 20px' }}>
        <Row className={styles.modalCardTitle}>AI Chat Plan</Row>
        <Row style={{ fontSize: '14px' }}>Focused purely on chat, simple and efficient</Row>
      </Card>

      <Row className={styles.modalCardTitle} style={{ padding: '40px 0 0 20px' }}>
        Price
      </Row>
      <Row className={[styles.modalCardTitle, styles.blueText]} style={{ paddingLeft: '20px' }}>
        $49 per month
      </Row>
    </Col>
    <Col xs={24} md={14}>
      <Row className={styles.modalCheckoutFeaturesTitle}>Features and benefits</Row>
      <Row className={styles.modalCheckoutFeaturesContent}>
        Get unlimited access to Taxaroo AI&apos;s chat for instant, secure task assistance and
        insights — no video needed. Perfect for quick, text-based solutions.
      </Row>
      <Row style={{ padding: '10px 0' }}>
        <video
          controls
          width="100%"
          style={{ maxWidth: '600px' }}
          controlsList="nodownload"
          poster={TaxarooAIVideoPoster}
          preload="metadata"
        >
          <source src={taxarooAiVideoSrc} type="video/mp4" />
          Your browser does not support the video tag.
          <track kind="captions" label="English" default />
        </video>
      </Row>
      <Row align="top">
        <Col flex="350px">
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            AI-powered chat for instant tax answers
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Unlimited text-based queries
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Quick task completion via chat interaction
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Available from your Firm Dashboard
          </Row>
          {/*
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Message history access up to 15 days
          </Row>
          */}
        </Col>
        <Col flex="auto">
          <Row className={styles.modalCheckoutFeaturesLine} style={{ opacity: 0.4 }}>
            <XMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Not available for Client Portal
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine} style={{ opacity: 0.4 }}>
            <XMark className={styles.modalCheckoutFeaturesBasicCheck} />
            AI Video not available
          </Row>
        </Col>
      </Row>
    </Col>
  </Row>
);

export const basicModalContent = (
  <Row justify="start" gutter={[30, 50]} className={styles.modalCheckoutContent}>
    <Col
      xs={24}
      md={8}
      style={{ marginRight: { xs: 0, md: '40px' }, marginBottom: { xs: '20px', md: 0 } }}
    >
      <Card
        className={styles.modalCardCheckout}
        bodyStyle={{ padding: '10px 20px' }}
      >
        <Row className={styles.modalCardTitle}>
          AI Video Plan
        </Row>
        <Row style={{ fontSize: '14px' }}>
          Includes 1-hour video sessions daily
        </Row>
      </Card>

      <Row className={styles.modalCardTitle} style={{ padding: '40px 0 0 20px' }}>
        Price
      </Row>
      <Row className={[styles.modalCardTitle, styles.blueText]} style={{ paddingLeft: '20px' }}>
        $299 per month
      </Row>
    </Col>
    <Col xs={24} md={14}>
      <Row className={styles.modalCheckoutFeaturesTitle}>Features and benefits</Row>
      <Row className={styles.modalCheckoutFeaturesContent}>
        The perfect starting point for firms looking to dip their toes into AI-powered efficiency.
        Gain the confidence to navigate your tax tasks with 1 daily session of cutting-edge support.
        Available exclusively on the firm page, it’s the ideal introduction to a smarter way of working.
      </Row>
      <Row style={{ padding: '10px 0' }}>
        <video
          controls
          width="100%"
          style={{ maxWidth: '600px' }}
          controlsList="nodownload"
          poster={TaxarooAIVideoPoster}
          preload="metadata"
        >
          <source src={taxarooAiVideoSrc} type="video/mp4" />
          Your browser does not support the video tag.
          <track kind="captions" label="English" default />
        </video>
      </Row>
      <Row align="top">
        <Col flex="350px">
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Includes 1-hour daily video session
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Speak conversationally with your AI agent
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Quick task completion via video interaction
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Available from your Firm Dashboard
          </Row>
          {/*
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Message history access up to 15 days
          </Row>
          */}
        </Col>
        <Col flex="auto">
          <Row className={styles.modalCheckoutFeaturesLine} style={{ opacity: 0.4 }}>
            <XMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Not available for Client Portal
          </Row>
        </Col>
      </Row>
    </Col>
  </Row>
);

export const premiumModalContent = (
  <Row justify="start" gutter={[30, 50]} className={styles.modalCheckoutContent}>
    <Col
      xs={24}
      md={8}
      style={{ marginRight: { xs: 0, md: '40px' }, marginBottom: { xs: '20px', md: 0 } }}
    >
      <Card className={styles.modalCardCheckoutPrimary} bodyStyle={{ padding: '10px 20px' }}>
        <Row className={[styles.modalCardTitle, styles.blueText]}>AI VideoPro Plan</Row>
        <Row style={{ fontSize: '14px' }}>Includes 2-hour video sessions daily</Row>
      </Card>

      <Row className={styles.modalCardTitle} style={{ padding: '40px 0 0 20px' }}>
        Price
      </Row>
      <Row className={[styles.modalCardTitle, styles.blueText]} style={{ paddingLeft: '20px' }}>
        $699 per month
      </Row>
    </Col>
    <Col xs={24} md={14}>
      <Row className={styles.modalCheckoutFeaturesTitle}>Features and benefits</Row>
      <Row className={styles.modalCheckoutFeaturesContent}>
        This is your gateway to longer sessions, firm-wide and client-facing power, and
        comprehensive message history. With extended transcription storage and unrestricted access,
        this is the ultimate tool to future-proof your tax operations.
      </Row>
      <Row style={{ padding: '10px 0' }}>
        <video
          controls
          width="100%"
          style={{ maxWidth: '600px' }}
          controlsList="nodownload"
          poster={TaxarooAIVideoPoster}
          preload="metadata"
        >
          <source src={taxarooAiVideoSrc} type="video/mp4" />
          Your browser does not support the video tag.
          <track kind="captions" label="English" default />
        </video>
      </Row>
      <Row align="top">
        <Col flex="350px">
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Enjoy 2-hour daily video sessions
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Speak conversationally with your AI agent
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            High-priority queue for urgent tasks
          </Row>
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Available from your Firm Dashboard
          </Row>
          {/*
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesBasicCheck} />
            Unlimited access to old messages
          </Row>
          */}
        </Col>
        <Col flex="auto">
          <Row className={styles.modalCheckoutFeaturesLine}>
            <CheckMark className={styles.modalCheckoutFeaturesPremiumCheckDark} />
            <Text
              style={{
                backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
                color: 'transparent',
                backgroundClip: 'text',
                fontWeight: 'bold',
              }}
            >
              Available for your clients too
            </Text>
            &nbsp;&nbsp;
            <MagicWand style={{ marginTop: '5px' }} />
            <Text
              style={{
                backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
                color: 'transparent',
                backgroundClip: 'text',
                marginLeft: '8px',
                lineHeight: '14px',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              Coming
              <br />
              Soon
            </Text>
          </Row>
        </Col>
      </Row>
    </Col>
  </Row>
);

export const DefaultModalCardButton = (
  defaultPaymentMethod: string,
  setPlan: (plan: AiAssistantPlanType) => void,
  planStatus: PlanStatus,
  price: string,
  plan: AiAssistantPlanType,
) => {
  if (planStatus === 'active') {
    return (
      <Button
        type="danger"
        disabled={!defaultPaymentMethod}
        onClick={() => setPlan(plan)}
      >
        Cancel subscription
      </Button>
    );
  }
  return (
    <Button
      type="primary"
      disabled={!defaultPaymentMethod}
      onClick={() => (defaultPaymentMethod ? setPlan(plan) : undefined)}
      style={
        plan !== 'AI VideoPro' ? { background: '#000', color: '#fff', borderColor: '#000' } : {}
      }
    >
      {defaultPaymentMethod
        ? `${planStatus === 'cancelsAtEndOfBillingCycle' ? 'Renew' : 'Get'} for ${price} per month`
        : 'Subscribe to Taxaroo first'}
    </Button>
  );
};

export const returnDefaultModalContent = (
  defaultPaymentMethod: string,
  setPlan: (plan: AiAssistantPlanType) => void,
  planStatuses: PlanStatusMap,
) => (
  <Row align="center">
    <Card className={styles.modalCard} bodyStyle={{ padding: '10px 20px' }}>
      <Row className={styles.modalCardTitle}>AI Chat Plan</Row>
      <Row style={{ fontSize: '14px' }}>Focused purely on chat, simple and efficient.</Row>

      <Row className={styles.modalCardFeatures}>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          AI-powered chat for instant tax answers
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Unlimited text-based queries
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Quick task completion via chat interaction
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Available from your Firm Dashboard
        </Row>
        {/*
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Message history access up to 15 days
        </Row>
        */}
      </Row>

      <Row className={styles.modalCardButton}>
        {DefaultModalCardButton(
          defaultPaymentMethod,
          setPlan,
          planStatuses?.['AI Chat'],
          '$49',
          'AI Chat',
        )}
      </Row>
    </Card>

    <Card className={styles.modalCard} bodyStyle={{ padding: '10px 20px' }}>
      <Row className={styles.modalCardTitle}>AI VideoPlus Plan</Row>
      <Row style={{ fontSize: '14px', marginBottom: '26px' }}>
        Includes 1-hour video sessions daily.
      </Row>

      <Row className={styles.modalCardFeatures}>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Includes 1-hour daily video session
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Speak conversationally with your AI agent
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Quick task completion via video interaction
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Available from your Firm Dashboard
        </Row>
        {/*
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Message history access up to 15 days
        </Row>
        */}
      </Row>

      <Row className={styles.modalCardButton}>
        {DefaultModalCardButton(
          defaultPaymentMethod,
          setPlan,
          planStatuses?.['AI VideoPlus'],
          '$299',
          'AI VideoPlus',
        )}
      </Row>
    </Card>

    <Card className={styles.modalCardPrimary} bodyStyle={{ padding: '10px 20px' }}>
      <Row className={[styles.modalCardTitle, styles.blueText]}>AI VideoPro Plan</Row>
      <Row style={{ fontSize: '14px', marginBottom: '26px' }}>
        Includes 2-hour video sessions daily.
      </Row>

      <Row className={styles.modalCardFeatures}>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Enjoy 2-hour daily video sessions
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Speak conversationally with your AI agent
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          High-priority queue for urgent tasks
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesBasicCheck} />
          Available from your Firm Dashboard
        </Row>
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesPremiumCheckDark} />
          <Text
            style={{
              backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
              color: 'transparent',
              backgroundClip: 'text',
              fontWeight: 'bold',
            }}
          >
            Available for your clients too
          </Text>
          &nbsp;&nbsp;
          <MagicWand style={{ marginTop: '5px' }} />
          <Text
            style={{
              backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
              color: 'transparent',
              backgroundClip: 'text',
              marginLeft: '8px',
              lineHeight: '14px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            Coming
            <br />
            Soon
          </Text>
        </Row>
        {/*
        <Row className={styles.modalCardFeaturesLine}>
          <CheckMark className={styles.modalCardFeaturesPremiumCheck} />
          Unlimited access to old messages
        </Row>
        */}
      </Row>

      <Row className={styles.modalCardButton}>
        {DefaultModalCardButton(
          defaultPaymentMethod,
          setPlan,
          planStatuses?.['AI VideoPro'],
          '$699',
          'AI VideoPro',
        )}
      </Row>
    </Card>
  </Row>
);
